import { useAuth } from "@/context/AuthContext";
import { FlaskConical } from "lucide-react";

// Subtle "SAMPLE DATA" tag shown on demo-tenant screens (timesheets, reports).
export function SampleDataBadge({ className = "" }) {
  const { motel } = useAuth();
  if (!motel?.is_demo) return null;
  return (
    <span
      data-testid="sample-data-badge"
      className={`inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-700 ${className}`}
    >
      <FlaskConical className="h-3 w-3" /> Sample data
    </span>
  );
}
